import debounce from 'lodash.debounce';

export const DROPDOWN_REDIRECT_ELEMENT = ".search-link[href='#search']";
export const DROPDOWN_SEARCH_ELEMENT = '.search-block';
export const DROPDOWN_SEARCH_FIELD_KEY = 'input.input--obscure';
export const RESULTS_DROPDOWN_KEY = '.finder__results-wrapper';
export const RESULTS_ROOT_KEY = '.finder__results';
export const RESULTS_SEARCH_ACTIVE_CLASS = 'finder__results--active';
export const RESULTS_LIST_KEY = '.finder__links';
export const RESULTS_LIST_ITEM_CLASS = 'finder__result';
export const RESULTS_LIST_ITEM_CLASS_KEY = `.${RESULTS_LIST_ITEM_CLASS}`;
export const DEBOUNCE_TIMEOUT = 500;
export const RESULTS_COUNTER_CLASS = 'finder__results--count';
export const NO_RESULTS_CLASS = 'no-results';
export const SEARCH_BUTTON = '.search-btn';
export const RESULTS_COLUMN_KEY = '.finder__results-column';
export const RESULTS_VIEW_CLASS = 'finder__results--view';

export const searchInput = jQuery(DROPDOWN_SEARCH_FIELD_KEY);

export class FinderComponent {
  get inputElement() {
    return jQuery(DROPDOWN_SEARCH_ELEMENT).find(DROPDOWN_SEARCH_FIELD_KEY);
  }

  get dropdownElement() {
    return jQuery(RESULTS_DROPDOWN_KEY);
  }

  constructor() {
    this.debouncedInputHandler = debounce(this.inputHandler.bind(this), DEBOUNCE_TIMEOUT);
  }

  init() {
    this.hideEmptyBlocks();
    this.inputElement.on('input change', this.debouncedInputHandler);

    jQuery(SEARCH_BUTTON).on('click', () => {
      this.redirectToSearchPage();
    });
    searchInput.on('keyup', (event) => {
      if (event.key === 'Enter') {
        this.redirectToSearchPage();
      }
    });
  }

  inputHandler(event) {
    const value = this.sanitizeValue(event.target.value).replace(/"/g, '');
    const isSearching = value.length >= 3;
    this.clearCount();
    this.showLoader();

    jQuery(RESULTS_ROOT_KEY).toggleClass(RESULTS_SEARCH_ACTIVE_CLASS, isSearching);

    if (!isSearching) {
      this.clearResults();
      this.clearCount();

      return;
    }

    this.loadResults(value);
  }

  clearResults() {
    jQuery(RESULTS_LIST_KEY).children(RESULTS_LIST_ITEM_CLASS_KEY).remove();
    this.hideEmptyBlocks();
  }

  clearCount() {
    if (typeof jQuery(RESULTS_DROPDOWN_KEY).children(`${RESULTS_VIEW_CLASS}`) !== 'undefined') {
      jQuery(RESULTS_DROPDOWN_KEY).children(`.${RESULTS_VIEW_CLASS}`).remove();
    } else {
      jQuery(RESULTS_DROPDOWN_KEY).children(`.${RESULTS_COUNTER_CLASS}`).remove();
    }
  }

  sanitizeValue(value) {
    return JSON.stringify(value.replace(/\s+/g, ' ')).trim();
  }

  hideEmptyBlocks() {
    jQuery(RESULTS_COLUMN_KEY).hide();
  }

  highlightString(value) {
    this.clearMarkedContent();

    const words = value.split(' ');

    words.forEach((value) => {
      this.highlightStringParts(value);
    });
  }

  highlightStringParts(value) {
    jQuery(`.${RESULTS_LIST_ITEM_CLASS}`).each((i, el) => {
      const regexp = new RegExp(value, 'i');

      this.highlightTitleString(el, regexp);
      this.highlightInfoString(el, regexp);
    });
  }

  clearMarkedContent() {
    jQuery(`.${RESULTS_LIST_ITEM_CLASS}`).each((i, el) => {
      const text = jQuery(el).html();
      const newText = text.replace('<mark>', '').replace('</mark>', '');

      jQuery(el).html(newText);
    });
  }

  highlightTitleString(el, regexp) {
    const title = jQuery(el).find('.teaser-title').html();

    if (typeof title !== 'undefined') {
      const resultTitle = regexp.exec(title);
      const newTitle = title.replace(regexp, `<mark>${resultTitle}</mark>`);

      jQuery(el).find('.teaser-title').html(newTitle);
    }
  }

  highlightInfoString(el, regexp) {
    const info = jQuery(el).find('.teaser-info').html();

    if (typeof info !== 'undefined') {
      const resultInfo = regexp.exec(info);
      const newInfo = info.replace(regexp, `<mark>${resultInfo}</mark>`);

      jQuery(el).find('.teaser-info').html(newInfo);
    }
  }

  redirectToSearchPage() {
    const inputValue = encodeURI(searchInput.val().trim());
    window.location.replace(`/search?query=${inputValue}`);
  }
}
